import { every, includes, isNil, isEmpty } from 'lodash'

export default {
    setBoolean: data => {
        return data === '1'
    },

    jsonParse: data => {
        if (!data) return null
        if (includes(data, '[') && includes(data, ']')) {
            return JSON.parse(data)
                .join(',')
                .replace(',', ', ')
        }
        return data
    },

    hasChild: data => {
        if (isNil(data) || isEmpty(data)) return false
        if (every(data, item => item.status === 'deleted')) return false
        return true
    }
}
